// extracted by mini-css-extract-plugin
export default {"modal":"adminModal_modal__k3y8J","login":"adminModal_login__D48hP","password":"adminModal_password__vbF0i","btns":"adminModal_btns__4sQlW"};